import { Card, Flex, Typography, Button } from "antd";
import { usePlans, featureIcons } from "./plans";
import { CheckOutlined } from "@ant-design/icons";
import clsx from "clsx";
import { useUserInfo } from "GlobalStates/User";
import { tierNames, tiers, tierToPaymentKey } from "Constants";
import { useMemo } from "react";
import "./styles.css";
import { ROUTES } from "Features/Routes/routeConstants";
import { useNavigate } from "react-router-dom";
const { Title, Paragraph, Text } = Typography;

export const PricingCards = ({ showHeading = true }) => {
  const { user } = useUserInfo();
  const navigate = useNavigate();
  const plans = usePlans();
  const plansToShow = useMemo(() => {
    if (user?.tier === tiers.STARTER) {
      return plans.filter((plan) => plan.name !== tierNames.STARTER);
    }
    if (user?.tier === tiers.ACHIEVER) {
      return plans.filter(
        (plan) =>
          plan.name !== tierNames.ACHIEVER && plan.name !== tierNames.STARTER
      );
    }
    return plans;
  }, [user, plans]);
  return (
    <div className="pricing-cards-section" id="pricing-cards-section">
      <div className="pricing-cards-container">
        {showHeading && (
          <>
            <Title level={1} className="pricing-cards-title">
              Choose Your Path to <br />
              <span className="pricing-cards-title-highlight">
                Academic Success
              </span>
            </Title>
            <Paragraph className="pricing-cards-subtitle">
              Select the plan that best fits your educational journey
            </Paragraph>
          </>
        )}
        <Flex wrap="wrap" gap="3em" justify="center">
          {plansToShow.map((plan, index) => (
            <div className="pricing-card-wrapper" key={index}>
              <Card
                className={`pricing-card ${
                  plan.highlight ? "highlight-card" : ""
                }`}
                bordered
                title={
                  <>
                    <div className="pricing-card-header">
                      <Title level={4} className="pricing-card-title">
                        {plan.name}
                      </Title>
                      <Paragraph className="pricing-card-subtitle">
                        {plan.subtitle}
                      </Paragraph>
                    </div>
                  </>
                }
              >
                <div className="pricing-price">
                  {plan.originalPrice && (
                    <Text delete className="original-price">
                      {plan.originalPrice}
                    </Text>
                  )}
                  <Text className="current-price">
                    {plan.price}{" "}
                    {plan.subtag && (
                      <span className="pricing-subtag">{plan.subtag}</span>
                    )}
                  </Text>{" "}
                </div>
                <div className="pricing-undertag">
                  {
                    <Text className="undertag font-bold text-black mb-1 text-sm">
                      {plan.undertag || ""}
                    </Text>
                  }
                </div>
                <Button
                  type={plan.highlight ? "primary" : "default"}
                  size="large"
                  className={clsx(
                    plan.highlight ? "green-button" : "white-button",
                    "pricing-action-button"
                  )}
                  onClick={() => {
                    if (!user?.token) {
                      navigate(
                        ROUTES.COLLEGE_FINDER_NEXT.replace(
                          ":next",
                          ROUTES.PRICING
                        )
                      );
                      return;
                    }
                    switch (plan.name) {
                      case tierNames.ACHIEVER:
                        navigate(ROUTES.PAYMENT, {
                          state: {
                            paymentKey: tierToPaymentKey[tiers.ACHIEVER],
                          },
                        });
                        break;
                      case tierNames.MENTORED:
                        navigate(ROUTES.PAYMENT, {
                          state: {
                            paymentKey: tierToPaymentKey[tiers.MENTORED],
                          },
                        });
                        break;
                      case tierNames.STARTER:
                        navigate(ROUTES.COLLEGE_FINDER);
                        break;
                      default:
                        break;
                    }
                  }}
                >
                  {plan.cta}
                </Button>
                {plan.badgeText && (
                  <div className="pricing-badge text-base">
                    {plan.badgeText}
                  </div>
                )}
                {Object.entries(plan.features).map(([category, items], i) => (
                  <div key={i} className="pricing-feature-section">
                    <Text strong className="pricing-feature-category text-base">
                      <span className="pricing-feature-icon">
                        {featureIcons[category]}
                      </span>{" "}
                      {category}
                    </Text>
                    <ul>
                      {items.map((feature, j) => (
                        <li
                          key={j}
                          className="pricing-feature-category-item text-base"
                        >
                          <CheckOutlined className="check-icon" />
                          {feature}
                        </li>
                      ))}
                    </ul>
                  </div>
                ))}
              </Card>
              {plan.name === tierNames.ACHIEVER && (
                <div className="most-chosen-badge">Most Chosen 🔥</div>
              )}
            </div>
          ))}
        </Flex>
      </div>
    </div>
  );
};
